import(/* webpackMode: "eager" */ "/vercel/path0/app/(global)/tarifs/page.tsx");
